import * as Animate from "react-reveal";
import Avatar1 from "../../../assets/images/png/avatars/1.webp";
import Avatar2 from "../../../assets/images/png/avatars/2.webp";
import Avatar3 from "../../../assets/images/png/avatars/3.webp";
import Avatar4 from "../../../assets/images/png/avatars/4.webp";

const workers = [
  {
    img: Avatar1,
    name: "Wanjiku N.",
    role: "Product Designer · Kenya",
    status: "Payroll Approved",
    value: "✓",
  },
  {
    img: Avatar2,
    name: "Amara O.",
    role: "Data Engineer · Nigeria",
    status: "Payroll Approved",
    value: "✓",
  },
  {
    img: Avatar3,
    name: "David K.",
    role: "Product Manager · United Kingdom",
    status: "Payout Processing",
    value: "Arrives Friday",
  },
  {
    img: Avatar4,
    name: "Tobi A.",
    role: "Software Engineer · United States",
    status: "Payroll Approved",
    value: "✓",
  },
];

const tags = ["Clarity", "Choice", "Care"];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayPeopleSection = () => {
  return (
    <section
      className="py-16 lg:py-[105px] px-6 lg:px-8"
      style={{ background: "#fff8e8" }}
      id="people"
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="max-w-[700px]">
            <p className="text-[#986500] tracking-[0.1em] uppercase text-[15px] font-black mb-4">
              For The People Being Paid
            </p>
            <h2
              className="text-primary tracking-[-0.05em] leading-[1.06] font-black mb-6"
              style={{ fontSize: "clamp(38px, 4.4vw, 61px)" }}
            >
              A good payday should feel clear{" "}
              <mark style={markStyle}>on both sides.</mark>
            </h2>
            <span className="text-[#5c6274] text-[18px] leading-[1.75] block">
              Your finance team needs oversight. Your workers need confidence.
              Utiva Pay helps everyone understand where payroll stands without
              long email chains or uncertainty.
            </span>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[14px] mt-10 lg:mt-[50px]">
          {workers.map((worker) => (
            <Animate.Fade bottom key={worker.name}>
              <article
                className="bg-white rounded-[17px] p-5"
                style={{ border: "1px solid #ead9ad" }}
              >
                <header className="flex items-center gap-3">
                  <img
                    src={worker.img}
                    alt={`${worker.name}, ${worker.role}`}
                    className="rounded-full object-cover"
                    style={{ width: "53px", height: "53px" }}
                  />
                  <p className="grid gap-1 m-0">
                    <strong className="text-primary text-[16px]">
                      {worker.name}
                    </strong>
                    <small className="text-[#5c6274] text-[15px]">
                      {worker.role}
                    </small>
                  </p>
                </header>

                <div
                  className="flex justify-between items-center gap-3 rounded-xl px-4 py-4 mt-7"
                  style={{ background: "#edf2ff" }}
                >
                  <span className="text-primary text-[15px] font-black uppercase">
                    {worker.status}
                  </span>
                  <b
                    className="text-[15px] font-normal"
                    style={{ color: "#1a7b44" }}
                  >
                    {worker.value}
                  </b>
                </div>

                <footer className="flex flex-wrap gap-[7px] mt-[18px]">
                  {tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-[#5c6274] rounded-full px-[9px] py-[7px] text-[15px] font-extrabold"
                      style={{ border: "1px solid #e2e6ef" }}
                    >
                      {tag}
                    </span>
                  ))}
                </footer>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PayPeopleSection;
